
import React, { useEffect, useRef } from "react";
import styles from "./styles/ScenarioCardOptions.module.css";

const ScenarioCardOptions = ({
    scenario,
    onClose,
    onDeleteScenario,
    onCopyScenario,
    navigate,
    isShared,
    isPinned,
    onPinScenario,
}) => {
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target) &&
                !event.target.closest(`.${styles.optionsButton}`)
            ) {
                onClose();
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [onClose]);

    return (

        <div className={styles.optionsDropdown} ref={dropdownRef}>
            {isShared ? (
             <div
                className={styles.dropdownItem}
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onClose();
                    navigate(`/create/${scenario._id}/canvas`);
                }}
            >
                Edit
            </div>
            
        ) : (
            <div>
             <div
                className={styles.dropdownItem}
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onClose();
                    navigate(`/create/${scenario._id}`);
                }}
            >
                Edit
            </div>
            <div
                className={styles.dropdownItem}
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onClose();
                    navigate(`/logs/heatmap/${scenario._id}`);
                }}
            >
                Logs
            </div>
            {/* Copy/Delete are hidden where the parent view doesn't support them (e.g. pinned cards on the profile) */}
            {onCopyScenario && (
                <div
                    className={styles.dropdownItem}
                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        onCopyScenario(e, scenario._id);
                        onClose();
                    }}
                >
                    Copy
                </div>
            )}
            {onDeleteScenario && (
                <div
                    className={styles.dropdownItem}
                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        onDeleteScenario(e, scenario._id);
                        onClose();
                    }}
                >
                    Delete
                </div>
            )}

            {/* Pin/Unpin Scenario — status loads when the menu opens; ignore clicks until it resolves */}
            <div
                className={styles.dropdownItem}
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    if (isPinned === null) return;
                    onPinScenario();
                    onClose();
                }}
            >
                {isPinned ? "Unpin" : "Pin"}
            </div>

            {/* Uncomment if Transfer is needed */}
            {/* <div
                className={styles.dropdownItem}
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    handleOpenTransfer();
                    onClose();
                }}
            >
                Transfer
            </div> */}
            </div>
        )}
        </div>
    );
};

export default ScenarioCardOptions;
